import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { ResizableTable } from "../../../components/resizableTable/ResizableTable";

const ForecastBestCasePaper = ({
  classes,
  paperTitle,
  isForecastBestCaseLoading,
  forecastBestCaseData,
  forecastBestCaseColumns,
  forecastBestCaseRows,
  getCellValue,
  getCellStyle,
  handleChangeLocation,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Typography variant="h6" className={classes.title}>
            Current Quarter – Best Case
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>
        {isForecastBestCaseLoading ? (
          <Skeleton variant="rect" animation="wave" height={200} width="100%" />
        ) : (
          <>
            {!forecastBestCaseData?.bestCaseOpps ||
            forecastBestCaseData.bestCaseOpps.length === 0 ? (
              <Box
                textAlign="center"
                py={4}
                style={{ fontStyle: "italic", color: "#666" }}
              >
                No best case opps found
              </Box>
            ) : (
              <ResizableTable
                columns={forecastBestCaseColumns}
                rows={forecastBestCaseRows}
                getCellValue={getCellValue}
                getCellStyle={getCellStyle}
                rowKey="label"
                hideSubHeaderRow={true}
                maxWidth="100%"
                onRowClick={(row) =>
                  handleChangeLocation("drilldownOnGraph", row, "bestCase")
                }
              />
            )}
          </>
        )}
      </Paper>
    </Grid>
  );
};

export default ForecastBestCasePaper;
